import { BetsLimitsType, ClientBetsType, IClientBet, ILimit } from 'widgets/Roulette/types';

import { all, call, put } from 'redux-saga/effects';

import { BetsTypes } from 'widgets/Roulette/const';
import { betsToBetsArray, sumBets } from 'widgets/Roulette/helpers';
import { addToastAction } from '../../Toast/actions';
import { ToastTypes } from 'types/toast';
import { betMessages } from 'constants/toastMessages';

export const countLimits = (
  limits: BetsLimitsType,
  config: { [index: string]: number },
): ILimit => {
  const keys = Object.keys(config);

  const min: number = keys.reduce((sum, key) => sum + limits[key].min * (config[key] ?? 1), 0);
  const max: number = keys.reduce((sum, key) => sum + limits[key].max * (config[key] ?? 1), 0);

  return { min, max };
};

export const getRaceTrackLimits = (limits: BetsLimitsType) => ({
  [BetsTypes.tier]: countLimits(limits, { [BetsTypes.split]: 6 }),
  [BetsTypes.orphelins]: countLimits(limits, {
    [BetsTypes.split]: 4,
    [BetsTypes.straight]: 1,
  }),
  [BetsTypes.voisins]: countLimits(limits, {
    [BetsTypes.split]: 5,
    [BetsTypes.street]: 1,
    [BetsTypes.corner]: 1,
  }),
  [BetsTypes.jeuZero]: countLimits(limits, {
    [BetsTypes.split]: 3,
    [BetsTypes.straight]: 1,
  }),
});

export const betChanger = (bet: number, currentBet: IClientBet) => ({ ...currentBet, bet });

export function* intersectForReducer(betValue: number, betInfo: IClientBet, { min, max }: ILimit) {
  if (betValue === 0) {
    return betChanger(0, betInfo);
  }

  if (betValue < min) {
    yield put(addToastAction({ type: ToastTypes.DEFAULT, value: betMessages.MIN_BET_REACHED }));
    return betChanger(min, betInfo);
  }

  if (betValue >= max) {
    if (betValue > max) {
      yield put(addToastAction({ type: ToastTypes.ERROR, value: betMessages.MAX_BET_REACHED }));
    }
    return betChanger(max, betInfo);
  }

  return betChanger(betValue, betInfo);
}

export function* intersects(
  bets: ClientBetsType,
  betsLimits: BetsLimitsType,
  intersectFunction: (
    bet: number,
    bets: IClientBet,
    limits: ILimit,
    type: string,
    selector: string,
  ) => void,
) {
  // @ts-ignore
  const betsArray: IClientBet[] = betsToBetsArray(bets);
  const sum = sumBets(betsArray);

  // @ts-ignore
  const betsWithLimits: any = yield all(
    betsArray.map((betinfo: IClientBet) => {
      const { bet = 0, type, selector } = betinfo;

      const racetrackLimits: BetsLimitsType = getRaceTrackLimits(betsLimits);

      const limits: ILimit = betsLimits[type]
        ? betsLimits[type]
        : racetrackLimits[type]
          ? racetrackLimits[type]
          : betsLimits[BetsTypes.straight];
      const betKey = selector.toString();

      // @ts-ignore
      return call<number, IClientBet, ILimit, string, string>(
        intersectFunction,
        bet,
        betinfo,
        limits,
        type,
        betKey,
      );
    }),
  );

  return betsWithLimits.reduce((acc: IClientBet[], item: IClientBet[]) => [...acc, item], []);
}

export function* validateForReducer(bets: ClientBetsType, betsLimits: BetsLimitsType) {
  const reduxBets: IClientBet[] = yield intersects(bets, betsLimits, intersectForReducer);
  return reduxBets;
}
